import gql from 'graphql-tag';

import {
  TraversalDirection,
  useArtifactDagQuery,
} from '../../../generated/graphql';
import {formatArtifactDagQuery, LineageQueryType} from '../utils';

export const ArtifactLineageDagFragment = gql`
  fragment GraphDataFragment on ArtifactLineageDag {
    artifacts {
      id
      artifactNodeID
      entityName
      projectName
      artifactTypeName
      artifactSequenceName
      artifactCommitHash
      versionIndex
    }
    runs {
      runNodeID
      entityName
      projectName
      runName
      displayName
      jobType
    }
    clusters {
      id
      nodeType
      runNodes {
        runNodeID
        entityName
        projectName
        runName
        displayName
        jobType
      }
      artifactNodes {
        id
        artifactNodeID
        entityName
        projectName
        artifactTypeName
        artifactSequenceName
        artifactCommitHash
        versionIndex
      }
      clusterEdges {
        edgeID
        artifactNodeID
        runNodeID
        clusterNodeID
        direction
      }
    }
    edges {
      edgeID
      artifactNodeID
      runNodeID
      clusterNodeID
      direction
    }
    hitLimit
  }
`;

export const ARTIFACT_DAG_QUERY = gql`
  query ArtifactDAG(
    $artifactVersionID: ID!
    $limit: Int!
    $filterGeneratedArtifacts: Boolean!
    $clusterSize: Int
    $directLineage: Boolean
    $traversalDirection: TraversalDirection
    $baseGraphNodeIDs: [String!]
  ) {
      artifact(id: $artifactVersionID) {
        id
        artifactLineageDag(
          limit: $limit
          filterGeneratedArtifacts: $filterGeneratedArtifacts
          clusterSize: $clusterSize
          directLineage: $directLineage
          traversalDirection: $traversalDirection
          baseGraphNodeIDs: $baseGraphNodeIDs
        ) {
          ...GraphDataFragment
        }
      }
    ${ArtifactLineageDagFragment}
  }
`;

export function useArtifactDagQueryCaller(
  artifactVersionID: string,
  artifactCommitHash: string,
  limit: number,
  filterGeneratedArtifacts: boolean,
  clusterSize?: number,
  directLineage?: boolean,
  traversalDirection?: TraversalDirection,
  baseGraphNodeIDs?: string[]
) {
  const {data, loading} = useArtifactDagQuery({
    variables: {
      artifactVersionID,
      limit,
      filterGeneratedArtifacts,
      clusterSize,
      directLineage,
      traversalDirection,
      baseGraphNodeIDs,
    },
    skip: artifactVersionID === '',
  });

  const {dag, limited} = formatArtifactDagQuery(
    data,
    LineageQueryType.ARTIFACT
  );

  return {
    dag,
    limited,
    loading,
  };
}
